var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name == 'PageNotFound')?[_c('router-view')]:[(_vm.showHeader)?_c('app-header'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"app-sidebar-right",attrs:{"id":"wrapper"}},[(_vm.showHeader)?_c('sidebar'):_vm._e(),_vm._v(" "),_c('router-view')],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f0dce58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 